export default __webpack_public_path__ + "static/media/Multiply.128211fa.svg";